import { render, staticRenderFns } from "./UserReviews.vue?vue&type=template&id=6d4ac6ef&scoped=true"
import script from "./UserReviews.vue?vue&type=script&lang=js"
export * from "./UserReviews.vue?vue&type=script&lang=js"
import style0 from "./UserReviews.vue?vue&type=style&index=0&id=6d4ac6ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4ac6ef",
  null
  
)

export default component.exports